import { makeStyles } from '@mui/styles';

const usePortfolioStyle = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  portfolioContainer: {
    width: '100%',
    marginTop: 50,
    zIndex: 2,
  },
  portfolioContainerMobile: {
    width: '100%',
    marginTop: 50,
    zIndex: 2,
  },
  header: {
    width: '100%',
    fontSize: 'max(3vw, 30px) !important',
    fontWeight: 'bolder !important',
    zIndex: 2,
    marginTop: '80px !important',
    fontFamily: 'Lato !important',
  },
});

export default usePortfolioStyle;
